import { useEffect, useState } from "react";

// Minutes since midnight, re-read once a minute.
//
// ⚠️ EXTRACTED BECAUSE A FOURTH COPY WAS ABOUT TO BE WRITTEN. BoardAPage,
// BoardBPage and BoardCPage each carry a byte-identical private
// `useNowMinutes`, and MobileTimeline inlines the same `useState` + interval a
// fourth time. When MobileShell needed a clock (2026-08-24, to release finished
// rooms onto the break board) that would have been the fifth. Those four are
// left alone deliberately — they work, and rewiring them belongs in its own
// change — but new callers import this one.
//
// ⚠️ DEVICE-LOCAL, LIKE EVERY OTHER CLOCK IN THE APP. `getHours()` reads the
// device's timezone, which is the same reading the chart's now-line and
// `roomsRunning` take. It is NOT the functions' hardcoded America/New_York (see
// the vault's "ATC dateKey has two definitions") — a wall device in the wrong
// timezone would draw its now-line wrong long before this mattered.
const TICK_MS = 60 * 1000;

const readNow = () => {
  const d = new Date();
  return d.getHours() * 60 + d.getMinutes();
};

export function useNowMinutes() {
  const [nowMin, setNowMin] = useState(readNow);
  useEffect(() => {
    const id = setInterval(() => setNowMin(readNow()), TICK_MS);
    return () => clearInterval(id);
  }, []);
  return nowMin;
}

export default useNowMinutes;
